import { getEntitySelectionKey } from "./entitySelectionKey";

export const buildSuggestionScoreMap = (entities, suggestions = []) => {
    const scoreBySelectionKey = {};
    suggestions.forEach((suggestion) => {
        const entity = entities.find(
            (entry) => entry.cdm_entity_name === suggestion.entity_name,
        );
        if (entity) {
            scoreBySelectionKey[getEntitySelectionKey(entity)] = suggestion.score;
        }
    });
    return scoreBySelectionKey;
};
